import React from 'react';

const FormParicion = ({ formDatos, setFormDatos }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">VID Cria</label>
      <input type="text" value={formDatos.cria_vid || ''} onChange={(e) => setFormDatos(p => ({ ...p, cria_vid: e.target.value }))}
        placeholder="VID cria" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-cria-vid" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Sexo Cria *</label>
      <select value={formDatos.sexo_cria || ''} onChange={(e) => setFormDatos(p => ({ ...p, sexo_cria: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
        <option value="">Seleccionar</option>
        <option value="macho">Macho</option>
        <option value="hembra">Hembra</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Peso Nacimiento (kg)</label>
      <input type="number" step="0.1" value={formDatos.peso_nacimiento || ''} onChange={(e) => setFormDatos(p => ({ ...p, peso_nacimiento: e.target.value }))}
        placeholder="35" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Tipo Parto</label>
      <select value={formDatos.tipo_parto || ''} onChange={(e) => setFormDatos(p => ({ ...p, tipo_parto: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-tipo-parto">
        <option value="">Seleccionar</option>
        <option value="normal">Normal</option>
        <option value="distocico">Distócico</option>
        <option value="cesarea">Cesárea</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Dificultad</label>
      <select value={formDatos.dificultad || ''} onChange={(e) => setFormDatos(p => ({ ...p, dificultad: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm">
        <option value="">Seleccionar</option>
        <option value="sin_ayuda">Sin Ayuda</option>
        <option value="con_ayuda">Con Ayuda</option>
        <option value="veterinario">Veterinario</option>
      </select>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Fecha Destete</label>
      <input type="date" value={formDatos.fecha_destete || ''} onChange={(e) => setFormDatos(p => ({ ...p, fecha_destete: e.target.value }))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Peso Destete (kg)</label>
      <input type="number" step="0.1" value={formDatos.peso_destete || ''} onChange={(e) => setFormDatos(p => ({ ...p, peso_destete: e.target.value }))}
        placeholder="180" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campo-peso-destete" />
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
      <input type="text" value={formDatos.observaciones || ''} onChange={(e) => setFormDatos(p => ({ ...p, observaciones: e.target.value }))}
        placeholder="Notas..." className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
    </div>
  </div>
);

export default FormParicion;
